import Resource from '@/api/resources/Resource'

class ComplementaryServices extends Resource {
    async getComplementaries(labId, caseId) {
        const response = await this.axios.get(`/common/laboratories/${labId}/cases/${caseId}/complementaries`)
        return response.data
    }
}

export default new ComplementaryServices()
